(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["benefits-timeline"] && !Shopify.designMode) return;
  try {
    
  (function () {
    document.querySelectorAll('.benefits-timeline').forEach(function (root) {
      if (root.dataset.btInit) return;
      root.dataset.btInit = 'true';
      root.classList.add('js');

      var items = root.querySelectorAll('.benefits-timeline__step, .benefits-timeline__cta');
      if (!('IntersectionObserver' in window)) {
        items.forEach(function (el) {
          el.classList.add('benefits-timeline--reveal');
        });
        return;
      }

      var io = new IntersectionObserver(
        function (entries) {
          entries.forEach(function (entry) {
            if (entry.isIntersecting) {
              entry.target.classList.add('benefits-timeline--reveal');
              io.unobserve(entry.target);
            }
          });
        },
        { threshold: 0.18, rootMargin: '0px 0px -8% 0px' }
      );
      items.forEach(function (el) {
        io.observe(el);
      });
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
